const ProjectCard = ({ image, alt, title, description, tags, link, disabled, buttonText = 'Launch' }) => (
  <div className='col-lg-6 col-12 mt-5'>
    <div className='card' style={{ height: '100%', width: '90%', marginLeft: '5%' }}>
      <img src={image} className='card-img-top' alt={alt} />
      <div className='card-body d-flex flex-column'>
        <h5 className='card-title'>{title}</h5>
        <p className='card-text'>{description}</p>
        <div className='d-flex flex-column flex-grow-1 justify-content-around'>
          <div className='tags'>
            {tags.map((tag, idx) => (
              <img key={idx} {...tag} alt={tag.alt || ''} className={'ms-1 ' + (tag.className || '')} />
            ))}
          </div>
          <div>
            {disabled ? (
              <button style={{ cursor: 'not-allowed' }} className='btn dimmed mt-3' disabled>
                {buttonText}
              </button>
            ) : (
              <a
                href={link}
                target='_blank'
                rel='noreferrer'
                className='btn btn-primary mt-3'
              >
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProjectCard;
